/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

class Switch {
  constructor(switchCheckbox = []) {
    this.switchCheckbox = switchCheckbox;
    this.events();
  }

  events() {
    this.switchCheckbox.addEventListener(
      "change",
      (event) => {
        event.preventDefault();

        // Każda zmianę switcha możemy nasłuchiwać.
        const customEvent = new CustomEvent("switch.change", {
          bubbles: true,
          detail: {
            switch: this.switchCheckbox,
          },
        });

        this.switchCheckbox.dispatchEvent(customEvent);
      },
      false
    );
  }
}

export { Switch };
